export function HelpPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <button 
            onClick={() => window.history.back()} 
            className="flex items-center text-gray-600 hover:text-gray-900 mb-6 transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Help Center</h1>
          <p className="text-xl text-gray-600 mb-8">Browse FAQs and guides to get the most out of OpenApps.</p>
          <p className="text-gray-700">Coming soon - comprehensive documentation and guides for getting started with AI agent infrastructure.</p>
        </div>
      </div>
    </div>
  )
}

export function CommunityPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <button 
            onClick={() => window.history.back()} 
            className="flex items-center text-gray-600 hover:text-gray-900 mb-6 transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Community</h1>
          <p className="text-xl text-gray-600 mb-8">Join discussions and share knowledge with other developers building AI agent infrastructure.</p>
          <p className="text-gray-700">Coming soon - connect with other developers, share best practices, and get help from the community.</p>
        </div>
      </div>
    </div>
  )
}

export function ContactPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <button 
            onClick={() => window.history.back()} 
            className="flex items-center text-gray-600 hover:text-gray-900 mb-6 transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Contact Us</h1>
          <p className="text-xl text-gray-600 mb-8">Get in touch with our team for support, partnerships, or general inquiries.</p>
          <div className="space-y-4">
            <p className="text-gray-700"><strong>General Inquiries:</strong> <a href="mailto:hello@openapps.ai" className="text-blue-600 hover:text-blue-800">hello@openapps.ai</a></p>
            <p className="text-gray-700"><strong>Technical Support:</strong> <a href="mailto:support@openapps.ai" className="text-blue-600 hover:text-blue-800">support@openapps.ai</a></p>
            <p className="text-gray-700"><strong>Sales & Partnerships:</strong> <a href="mailto:experts@openapps.ai" className="text-blue-600 hover:text-blue-800">experts@openapps.ai</a></p>
          </div>
        </div>
      </div>
    </div>
  )
}

export function SecurityPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <button 
            onClick={() => window.history.back()} 
            className="flex items-center text-gray-600 hover:text-gray-900 mb-6 transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Security</h1>
          <p className="text-xl text-gray-600 mb-8">Our approach to security and compliance for AI agent infrastructure.</p>
          <div className="space-y-4">
            <p className="text-gray-700">Security is at the core of OpenApps. We implement enterprise-grade security measures including:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>End-to-end encryption for all data in transit and at rest</li>
              <li>Zero-trust security model with granular access controls</li>
              <li>SOC2 Type II compliance and regular security audits</li>
              <li>Real-time threat detection and automated response</li>
            </ul>
            <p className="text-gray-700 mt-6">For security inquiries or to report vulnerabilities, contact: <a href="mailto:security@openapps.ai" className="text-blue-600 hover:text-blue-800">security@openapps.ai</a></p>
          </div>
        </div>
      </div>
    </div>
  )
}


